import { DataProductService } from '@/api/services/DataProductService';
import { GetDataProductResponseDto } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getDataProductByIdTool: ToolDefinition = {
  name: 'get_data_product_by_id',
  description: 'Get data product details by ID. Use for specific data product details. If only name provided, use search_data_products first to get ID. Returns: id, name, description, sla, owners (shown as "assignees"), assetInput (configuration), collaborationToolsParams. Data products separate from assets. Use search_assets for assets.',
  input_schema: {
    type: 'object',
    properties: {
      id: {
        type: 'string',
        description: 'Data product UUID. Use search_data_products first if only name provided.',
      },
    },
    required: ['id'],
  },
};

/**
 * Execute the get_data_product_by_id tool
 */
export async function executeGetDataProductById(
  params: { id: string },
): Promise<GetDataProductResponseDto | { error: string }> {
  try {
    const result = await callWithContext('sifflet-ai-chat', () => DataProductService.getDataProduct({
      id: params.id,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getDataProductByIdTool;
